// extracted by mini-css-extract-plugin
module.exports = {"container":"dZ","title":"d0","tabs":"d1","text":"d2","textForm":"d3","submitButton":"d4","checkboxContainer":"d5","errorMessage":"d6"};